"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVUtils = void 0;
const jsonexport = require('jsonexport/dist');
const fileDownload = require('js-file-download');
const lodash_1 = __importDefault(require("lodash"));
exports.CSVUtils = {
    prepareAndDownload: (dataSource, identifier = "", options = {}) => {
        (async () => {
            try {
                const fileName = lodash_1.default.compact([identifier]).join("_");
                const csv = await jsonexport(dataSource, { ...options });
                fileDownload(csv, `${fileName}_${new Date().getTime()}.csv`);
            }
            catch (err) {
                console.error(err);
            }
        })();
    },
};
